<template>
  <div class="col-auto mb-3 card-w mx-auto">
    <div class="ProductCard position-relative" v-if="obj" :class=" obj.available === false ? 'fade' : ''">
        <div dir="rtl" class="p-2">
          <span class="off" v-if="obj.isOffInt && obj.priceBeforeOff !== obj.priceAfterOff">{{calPercentage(obj.priceBeforeOff,obj.priceAfterOff)}}%</span>
          <span class="off" v-if="!obj.isOffInt && obj.priceBeforeOff !== obj.priceAfterOff">حراج</span>
          <span class="special-tag" v-if="obj.specialTag">{{obj.specialTag}}</span>
          <span class="unavailable" v-if="obj.available === false">ناموجود</span>
          <router-link @dragstart.prevent :to="'/product/' + obj.categorySlug + '/' + obj.subCategorySlug + '/' + obj.slug ">
            <img class="SimpleCardImage" :style="'background: center / contain no-repeat url(' + $MEDIA + $categories.filter(item => item.id == obj.categoryId)[0].backgroundLight +');'" :alt="obj.name" :title="obj.name" v-lazy="$RESIZE + obj.image + '&product=1'" />
          </router-link>
          <div class="p-1 min-h">
            <router-link @dragstart.prevent :title="name" :to="'/product/' + obj.categorySlug + '/' + obj.subCategorySlug + '/' + obj.slug ">
              <h3 class="p-name">{{strLimit(name,50)}}</h3>
            </router-link>
            <p class="my-2 d-flex justify-content-between">
              <span class="btns">
                <i v-if="obj.available === true && obj.priceAfterOff != 0" @click="addToCart(obj)" class="fa-solid fa-shopping-cart pointer"></i>
                <i v-if="obj.available === true && obj.priceAfterOff == 0" @click="checkPrice(obj.id)" class="fa-solid fa-shopping-cart pointer"></i>
                <i v-if="obj.available === false" @click="checkAvailable(obj.id)" class="fa-solid fa-shopping-cart pointer"></i>
                <i @click="addToWish(obj);isLike = !isLike" v-if="!isLike" class="fa-solid fa-heart mx-2 pointer"></i>
                <i @click="removeFromWish(obj);isLike = !isLike" v-if="isLike" style="color:red;" class="fa-solid fa-heart mx-2 pointer"></i>

                <router-link :to="'/cam/' + obj.slug" class="text-purple" v-if="obj.mlActivation">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-badge-ar" viewBox="0 0 16 16">
                    <path d="m3.794 11 .47-1.542H6.27L6.739 11H8L5.996 5.001H4.607L2.595 11zm1.503-4.852.734 2.426h-1.52l.734-2.426zm5.598-1.147H8.5V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9zm-1.222 2.87V5.933h1.05c.63 0 1.05.347 1.05.989 0 .633-.408.95-1.067.95z"/>
                    <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
                  </svg>
                </router-link>

              </span>
              <span dir="ltr" v-if="obj.priceBeforeOff !== obj.priceAfterOff && obj.available === true && obj.priceAfterOff != 0">
                <span class="price-del m-0"><del>{{obj.priceBeforeOff.toLocaleString('fa')}}</del></span>
                <span class="price m-0">{{obj.priceAfterOff.toLocaleString('fa')}}</span>
                <ToomanSvg />
              </span>
              <span dir="ltr" v-if="obj.priceBeforeOff === obj.priceAfterOff && obj.available === true && obj.priceAfterOff != 0">
                <span class="price my-3">{{obj.priceAfterOff.toLocaleString('fa')}}</span>
                <ToomanSvg />
              </span>
              <span dir="ltr" v-if="obj.available === true && obj.priceAfterOff == 0">
                <span @click="checkPrice(obj.id)" class="my-3 text-check-price pointer">قیمت را استعلام بگیرید</span>
              </span>
              <span dir="ltr" v-if="obj.available === false">
                <span @click="checkAvailable(obj.id)" class="my-3 text-check-price pointer">استعلام شارژ مجدد</span>
              </span>
            </p>
          </div>
        </div>
    </div>
      <div class="ProductCard position-relative" v-if="!obj">
        <div dir="rtl" class="p-2">
          <img src="../assets/product-card.webp" class="w-100 h-100">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductCard',
  props: {
    obj: JSON,
    remove: String
  },
  data () {
    return {
      isLike: false,
      name: ''
    }
  },
  methods: {
    calPercentage: function (before, after) {
      const percentage = parseInt((before - after) * 100 / before)
      return percentage.toLocaleString('fa')
    },
    load: function () {
      this.isLike = JSON.parse(localStorage.getItem('wish')) ? JSON.parse(localStorage.getItem('wish'))[this.obj.id] : false
      this.name = this.obj.name
      if (this.remove) {
        const removes = this.remove.split(',')
        for (const x of removes) {
          this.name = this.name.replace(x, '')
        }
      }
    }
  },
  mounted () {
    if (this.obj) {
      this.load()
    }
  },
  watch: {
    obj: function () {
      if (this.obj) {
        this.load()
      }
    }
  }
}
</script>
<style scoped>
.fade{
  opacity: 0.7;
}
.min-h{
  min-height: 114px;
}
.text-check-price{
  color: black;
  font-size: 10pt;
}
.btns{
  display: flex;
  align-content: flex-end;
  align-items: flex-end;
  padding: 0px 0px 4px 0px;
}
.p-name{
  min-height: 48px;
}
.price{
  color: black;
  font-size: 14pt;
  font-weight: bold;
}
.price-del{
  position: absolute;
  left: 15px;
  bottom: 38px;
  letter-spacing: -0.5px;
}
del{
  color: gray;
  font-size: 12pt;
  font-weight: 500;
}
.off{
  font-weight: bold;
  background: #b4aaf3;
  color: #000;
  padding: 5px 15px;
  position: absolute;
  border-radius: 16px;
  top: 12px;
  left: 12px;
}
.special-tag{
  font-weight: bold;
  background: #a37e2c;
  color: white;
  padding: 5px 15px;
  position: absolute;
  border-radius: 16px;
  top: 12px;
  right: 12px;
}
.unavailable{
  background: #ff5f5f;
  color: black;
  padding: 5px 15px;
  position: absolute;
  border-radius: 5px;
  right: 7px;
  top: 7px;
}
.fa-solid{
  font-size: 14pt;
}
@media (max-width: 500px) {
  .card-w{
    width: 300px!important;
  }
}
.card-w{
  width: 300px;
}
img{
  width:170px;
  height:170px;
}
h3{
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;
  text-align: right;
  color: #121212;
  margin-top:12px;
  padding:0px 12px;
}
p{
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 162%;
  text-align: right;
  color: #4F4F4F;
  padding:0px 12px;
  font-family:"IRANSans";
}
span{
  color:#BDBDBD;
}
.price{
  font-style: normal;
  line-height: 162%;
  text-align: right;
  font-family:"IRANSans";
  text-align: left;
}
.price span{
  margin-right: 48px;
}
.ProductCard{
  border: solid 1px #d1d1d1;
  border-radius:24px;
  height: 100% !important;
  margin: 0px auto;
  padding:0px;
  background: white;
  transition: 0.4s;
}
.ProductCard:hover{
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px white;
}
.SimpleCardImage{
  width:100%;
  height:100%;
}
@keyframes shapes {
  0%   {border-radius: 70% 30% 57% 43% / 56% 46% 54% 44% ; }
  25%  {border-radius: 34% 66% 38% 62% / 56% 46% 54% 44% ; }
  50%  {border-radius: 33% 67% 38% 62% / 39% 40% 60% 61% ; }
  75%  {border-radius: 33% 67% 38% 62% / 65% 40% 60% 35% ; }
  100% {border-radius: 70% 30% 57% 43% / 56% 46% 54% 44% ; }
}
</style>
